import Swiper, { EffectFade, Autoplay } from "swiper";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

const $ = jQuery;

export default class Swipers {
    constructor(options = null) {}

    init() {
        this.__swiper();
    }

    __swiper() {
        const $swiperBlocks = $(".testimonials_swiper_block");

        // Iterate through both sets of Swiper blocks
        $swiperBlocks.each((index, swiperBlock) => {
            if (!swiperBlock) return;

            const swiperBlockId = $(swiperBlock).attr("id");

            const mainSwiper = new Swiper(`#${swiperBlockId}`, {
                speed: 2000,
                slidesPerView: 1,
                pauseOnMouseEnter: true,
                effect: "fade",
                fadeEffect: {
                    crossFade: true,
                },
                autoplay: {
                    delay: 7500, // Delay between slides in milliseconds
                    disableOnInteraction: false, // Ensures autoplay continues after user interaction
                },
                loop: true,
                modules: [EffectFade, Autoplay],
            });
        });
    }
}
